// Mock data & bilingual content for La Bellavita Rooms
// NOTE: All content here is MOCKED for the frontend-only version.

export const CONTACT = {
  address: 'Viale Stefano Candura, 28 \u2013 93100 Caltanissetta',
  phone: '+39 0934 545257',
  phoneHref: '+390934545257',
  email: 'info@labellavita.cloud',
  mapsUrl: 'https://www.google.com/maps?q=Viale+Stefano+Candura+28,+93100+Caltanissetta,+Sicilia',
  social: {
    instagram: 'https://www.instagram.com/la_bellavita_rooms/',
    facebook: 'https://www.facebook.com/people/La-Bellavita-Rooms/pfbid02uE8JAq2h1ypv8WUmVr7XHQdvXFvWMCwdmvASmfaXRN7FZqYMzVYY5Y84XYck9hpnl/',
  },
};

export const HERO_IMAGES = {
  town: '/images/house/spazi2.webp',
  original: '/images/house/entrance.jpg',
};

// Hero carousel \u2014 surroundings / area of Caltanissetta & central Sicily (not a private view).
export const HERO_CAROUSEL = [
  'https://images.unsplash.com/photo-1560189469-bd095209c1e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
  'https://images.unsplash.com/photo-1656712001654-0c34917b2830?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
  'https://images.unsplash.com/photo-1632316605108-b03499851b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
  'https://images.unsplash.com/photo-1689500574231-66daad1cfcd8?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
  'https://images.unsplash.com/photo-1602566126756-c5d59c4a560d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
];

// Photo credits. Room & property photos belong to La Bellavita Rooms.
// Ambient / landscape photos are provided by Unsplash (link to each source).
export const PHOTO_CREDITS = {
  own: {
    it: 'Fotografie delle camere e della struttura',
    en: 'Photos of the rooms and the property',
    author: 'ritratticamilleri_fotografia',
    authorUrl: 'https://www.instagram.com/ritratticamilleri_fotografia/',
  },
  unsplash: [
    { section: { it: 'Home \u2014 dintorni di Caltanissetta (carosello)', en: 'Home \u2014 Caltanissetta surroundings (carousel)' }, url: 'https://unsplash.com/photos/bd095209c1e8' },
    { section: { it: 'Cosa fare \u2014 Cucina & Sapori', en: 'What to do \u2014 Cuisine & Flavours' }, url: 'https://unsplash.com/photos/0cc19062f912' },
    { section: { it: 'Cosa fare \u2014 Il Mare', en: 'What to do \u2014 The Sea' }, url: 'https://unsplash.com/photos/c780e5eabe53' },
    { section: { it: 'Cosa fare \u2014 Barocco & Cattedrali', en: 'What to do \u2014 Baroque & Cathedrals' }, url: 'https://unsplash.com/photos/d4a6f7d04e79' },
    { section: { it: 'Cosa fare \u2014 Borghi & Vicoli', en: 'What to do \u2014 Villages & Alleys' }, url: 'https://unsplash.com/photos/af81877265b1' },
    { section: { it: 'Cosa fare \u2014 Coste & Calette', en: 'What to do \u2014 Coasts & Coves' }, url: 'https://unsplash.com/photos/1d0d16415856' },
    { section: { it: 'Cosa fare \u2014 Paesi sul Mare', en: 'What to do \u2014 Seaside Towns' }, url: 'https://unsplash.com/photos/3d3b72a5dc79' },
  ],
};


export const rooms = [
  {
    id: 'gialla',
    accent: '#D69A4C',
    name: { it: 'La Camera Gialla', en: 'The Yellow Room' },
    subtitle: { it: 'Luce e calore del sole siciliano', en: 'Light and warmth of the Sicilian sun' },
    desc: {
      it: 'Una stanza luminosa dai toni dorati, pensata per risvegliarsi con la luce del mattino. Arredi curati, tessuti naturali e un\u2019atmosfera che profuma di Sicilia.',
      en: 'A bright room in golden tones, designed to wake up with the morning light. Careful furnishings, natural fabrics and an atmosphere that smells of Sicily.',
    },
    images: [
      '/images/rooms/bed1c.webp',
      '/images/rooms/bed1a.webp',
      '/images/rooms/bed1d.webp',
      '/images/rooms/bed1b.webp',
    ],
  },
  {
    id: 'arancione',
    accent: '#B5603A',
    name: { it: 'La Camera Arancione', en: 'The Orange Room' },
    subtitle: { it: 'L\u2019energia calda della terra', en: 'The warm energy of the land' },
    desc: {
      it: 'Toni terracotta e dettagli avvolgenti per una camera dal carattere deciso e accogliente, ispirata ai colori del tramonto sull\u2019isola.',
      en: 'Terracotta tones and enveloping details for a room with a bold, welcoming character, inspired by the colours of sunset over the island.',
    },
    images: [
      '/images/rooms/bed2b.jpg',
      '/images/rooms/bed2c.jpg',
      '/images/rooms/bed2a.jpg',
    ],
  },
  {
    id: 'blu',
    accent: '#35617D',
    name: { it: 'La Camera Blu', en: 'The Blue Room' },
    subtitle: { it: 'La quiete del mare Mediterraneo', en: 'The calm of the Mediterranean sea' },
    desc: {
      it: 'Sfumature di blu profondo che richiamano il mare di Sicilia: una camera serena e rilassante, perfetta per riposare dopo una giornata di scoperte.',
      en: 'Shades of deep blue that recall the Sicilian sea: a serene and relaxing room, perfect for resting after a day of discovery.',
    },
    images: [
      '/images/rooms/bed3.webp',
      '/images/rooms/bed3a.jpg',
      '/images/rooms/bed3c.jpg',
    ],
  },
];

export const experiences = [
  {
    id: 'cucina',
    image: 'https://images.unsplash.com/photo-1600835768553-0cc19062f912',
    tag: { it: 'Sapori', en: 'Flavours' },
    title: { it: 'Cucina & Sapori Siciliani', en: 'Sicilian Cuisine & Flavours' },
    desc: {
      it: 'Cannoli, dolci di mandorla e street food: un viaggio nei sapori pi\u00f9 autentici dell\u2019isola, dalle botteghe ai mercati storici.',
      en: 'Cannoli, almond sweets and street food: a journey through the most authentic flavours of the island, from artisan shops to historic markets.',
    },
  },
  {
    id: 'mare',
    image: 'https://images.unsplash.com/photo-1531937363610-c780e5eabe53',
    tag: { it: 'Mare', en: 'Sea' },
    title: { it: 'Il Mare della Sicilia', en: 'The Sicilian Sea' },
    desc: {
      it: 'Acque cristalline e coste dorate a poca distanza: giornate di sole tra spiagge e piccole calette nascoste.',
      en: 'Crystal-clear waters and golden coasts a short distance away: sunny days between beaches and small hidden coves.',
    },
  },
  {
    id: 'barocco',
    image: 'https://images.unsplash.com/photo-1561280618-d4a6f7d04e79',
    tag: { it: 'Storia', en: 'History' },
    title: { it: 'Barocco & Cattedrali', en: 'Baroque & Cathedrals' },
    desc: {
      it: 'Il barocco siciliano, patrimonio UNESCO: chiese, palazzi e piazze che raccontano secoli di arte e devozione.',
      en: 'Sicilian Baroque, a UNESCO heritage: churches, palaces and squares that tell centuries of art and devotion.',
    },
  },
  {
    id: 'borghi',
    image: 'https://images.unsplash.com/photo-1675026923185-af81877265b1',
    tag: { it: 'Borghi', en: 'Villages' },
    title: { it: 'Borghi & Vicoli Antichi', en: 'Old Villages & Alleys' },
    desc: {
      it: 'Passeggiate tra vicoli di pietra, torri campanarie e scorci senza tempo nel cuore della Sicilia.',
      en: 'Strolls through stone alleys, bell towers and timeless views in the heart of Sicily.',
    },
  },
  {
    id: 'coste',
    image: 'https://images.unsplash.com/photo-1615693128306-1d0d16415856',
    tag: { it: 'Natura', en: 'Nature' },
    title: { it: 'Coste & Calette', en: 'Coasts & Coves' },
    desc: {
      it: 'Scogliere, insenature turchesi e sentieri panoramici per gli amanti della natura e del trekking leggero.',
      en: 'Cliffs, turquoise inlets and scenic trails for lovers of nature and light trekking.',
    },
  },
  {
    id: 'paesi',
    image: 'https://images.unsplash.com/photo-1558652361-3d3b72a5dc79',
    tag: { it: 'Panorami', en: 'Views' },
    title: { it: 'Paesi sul Mare', en: 'Seaside Towns' },
    desc: {
      it: 'Piccoli centri affacciati sul Mediterraneo, dove il tempo scorre lento tra chiese, porti e tramonti.',
      en: 'Small towns overlooking the Mediterranean, where time flows slowly between churches, harbours and sunsets.',
    },
  },
];

export const translations = {
  it: {
    nav: { home: 'Home', rooms: 'Le camere', experiences: 'Cosa fare', contact: 'Contatti', book: 'Prenota' },
    hero: {
      kicker: 'Accoglienza in Sicilia',
      title: 'la Bellavita',
      title2: 'rooms',
      subtitle: 'Un racconto autentico di Sicilia, tra storia, sapori e ospitalit\u00e0.',
      cta1: 'Scopri le camere',
      cta2: 'Contattaci',
      scroll: 'Scorri',
    },
    about: {
      kicker: 'Benvenuti',
      title: 'Il calore della Sicilia,\nsentirsi subito a casa',
      p1: 'Quello che offro ai miei ospiti \u00e8 il mio racconto della Sicilia: una terra dalla storia affascinante, dalle tradizioni vive e dalla straordinaria capacit\u00e0 di accogliere.',
      p2: 'Attraverso esperienze, luoghi e sapori, condivido il volto pi\u00f9 autentico di un\u2019isola dove l\u2019ospitalit\u00e0 \u00e8 un valore profondo e il calore umano fa sentire subito a casa.',
      stat1: 'Camere', stat1v: '3',
      stat2: 'nel cuore della', stat2v: 'Sicilia',
      stat3: 'Ospitalit\u00e0', stat3v: '100%',
    },
    rooms: {
      kicker: 'Le camere',
      title: 'Tre stanze, tre atmosfere',
      subtitle: 'Ogni camera porta il nome di un colore e racconta un lato diverso della Sicilia.',
      view: 'Vedi la galleria',
      amenitiesTitle: 'Servizi',
    },
    amenities: ['Wi-Fi gratuito', 'Aria condizionata', 'Bagno privato', 'Colazione', 'Biancheria inclusa', 'Vista sulla citt\u00e0'],
    experiences: {
      kicker: 'Cosa fare',
      title: 'Esperienze da vivere',
      subtitle: 'Dalla tavola al mare, dalla storia ai borghi: la Sicilia da scoprire attorno a te.',
    },
    contact: {
      kicker: 'Contatti',
      title: 'Prenota il tuo soggiorno',
      subtitle: 'Scrivimi per informazioni e disponibilit\u00e0: risponder\u00f2 personalmente.',
      name: 'Nome', email: 'Email', dates: 'Date del soggiorno', guests: 'Ospiti', message: 'Messaggio',
      placeholderMsg: 'Raccontami quando vorresti venire e cosa cerchi...',
      send: 'Invia richiesta',
      sending: 'Invio in corso...',
      addressLabel: 'Indirizzo', phoneLabel: 'Telefono', emailLabel: 'Email',
      directions: 'Apri in Google Maps',
      success: 'Grazie! La tua richiesta \u00e8 stata inviata. Ti risponder\u00f2 al pi\u00f9 presto.',
      error: 'Ops, invio non riuscito. Riprova o scrivici via email.',
    },
    footer: {
      tagline: 'Accoglienza in Sicilia \u00b7 Sicilian Hospitality',
      rights: 'Tutti i diritti riservati.',
      credits: 'Credits',
      made: 'Realizzato con cura in Sicilia',
      reserved: 'Area riservata',
    },
    credits: {
      title: 'Crediti fotografici',
      intro: 'Un sentito ringraziamento a chi ha reso possibile il racconto per immagini di questo sito.',
      ownTitle: 'Foto della struttura',
      unsplashTitle: 'Immagini paesaggistiche \u2014 via Unsplash',
      unsplashNote: 'Le immagini ambientali sono fornite gratuitamente da Unsplash. Clicca su ciascuna voce per vedere la foto e il suo autore.',
      view: 'Vedi su Unsplash',
      close: 'Chiudi',
    },
  },
  en: {
    nav: { home: 'Home', rooms: 'Rooms', experiences: 'What to do', contact: 'Contact', book: 'Book' },
    hero: {
      kicker: 'Sicilian Hospitality',
      title: 'la Bellavita',
      title2: 'rooms',
      subtitle: 'An authentic story of Sicily \u2014 history, flavours and heartfelt hospitality.',
      cta1: 'Discover the rooms',
      cta2: 'Get in touch',
      scroll: 'Scroll',
    },
    about: {
      kicker: 'Welcome',
      title: 'The warmth of Sicily,\nfeel at home right away',
      p1: 'What I offer my guests is my own story of Sicily \u2014 a land rich in history, vibrant traditions, and an extraordinary sense of welcome.',
      p2: 'Through experiences, places, and flavours, I share the most authentic side of the island, where hospitality is a true way of life and warmth makes you feel at home from the very first moment.',
      stat1: 'Rooms', stat1v: '3',
      stat2: 'in the heart of', stat2v: 'Sicily',
      stat3: 'Hospitality', stat3v: '100%',
    },
    rooms: {
      kicker: 'Our rooms',
      title: 'Three rooms, three atmospheres',
      subtitle: 'Each room is named after a colour and tells a different side of Sicily.',
      view: 'View gallery',
      amenitiesTitle: 'Amenities',
    },
    amenities: ['Free Wi-Fi', 'Air conditioning', 'Private bathroom', 'Breakfast', 'Linen included', 'City view'],
    experiences: {
      kicker: 'What to do',
      title: 'Experiences to live',
      subtitle: 'From the table to the sea, from history to old villages: Sicily to discover around you.',
    },
    contact: {
      kicker: 'Contact',
      title: 'Book your stay',
      subtitle: 'Write to me for information and availability \u2014 I will reply personally.',
      name: 'Name', email: 'Email', dates: 'Stay dates', guests: 'Guests', message: 'Message',
      placeholderMsg: 'Tell me when you would like to come and what you are looking for...',
      send: 'Send request',
      sending: 'Sending...',
      addressLabel: 'Address', phoneLabel: 'Phone', emailLabel: 'Email',
      directions: 'Open in Google Maps',
      success: 'Thank you! Your request has been sent. I will reply as soon as possible.',
      error: 'Oops, sending failed. Please try again or email us.',
    },
    footer: {
      tagline: 'Sicilian Hospitality \u00b7 Accoglienza in Sicilia',
      rights: 'All rights reserved.',
      credits: 'Credits',
      made: 'Made with care in Sicily',
      reserved: 'Reserved area',
    },
    credits: {
      title: 'Photo credits',
      intro: 'A heartfelt thank you to those who made the visual storytelling of this website possible.',
      ownTitle: 'Property photos',
      unsplashTitle: 'Landscape images \u2014 via Unsplash',
      unsplashNote: 'The ambient images are provided free of charge by Unsplash. Click each item to view the photo and its author.',
      view: 'View on Unsplash',
      close: 'Close',
    },
  },
};
